import React from "react";
import {VisibilityHandler} from "../common/VisibilityHandler";
import { makeStyles} from "@mui/styles";
import {Theme} from "@mui/material";


export interface VerticalNavigationBarProps {
    isAppBarOpen: boolean
    children: React.ReactNode | React.ReactNode[]
}


const useStyle = makeStyles((theme: Theme) => ({
    sectionDesktop: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
            flexDirection: 'column',
            width: '70px',
            position: 'fixed',
            marginRight: '15px',
            marginTop: '64px',
            minHeight: 100+'vh',
        },
    }
}));

export function VerticalNavigationBar({ isAppBarOpen,  children }: VerticalNavigationBarProps) {
    const classes = useStyle();

    return (
        <VisibilityHandler isVisible={ isAppBarOpen  }>
            <div className={ classes.sectionDesktop + " nav-drawer-background menu-border-hidden" }>
                {children}
            </div>
        </VisibilityHandler>
    );
}